import { Observable } from "rxjs";

export interface NotificationArgs {
  title: string;
  type: DialogType;
  message: string | string[];
  /** the result of closing the dialog (default to false) */
  result: Observable<boolean>;
  confirmButtonName: string;
  discardButtonName: string;
}

export enum DialogType {
  Notification = 1,
  Alert = 2
}
